import logo from "../../logo.svg";
import { resolvePhotoUrl } from "./resolvePhotoUrl";

/**
 * Checks if the user or store has an active premium package.
 * Premium package is identified by:
 * - auth.package.planLimited === "premium"
 * - auth.package.pId === "AID-POS-03" or ends with "-03" / "-04"
 * - settings.pId (AID-POS-03 / AID-POS-04)
 * - package or plan string containing "premium"
 */
export const isPremiumUser = (auth, dbSettings) => {
  const pkg = auth?.package;
  const planLimited = pkg?.planLimited || pkg?.plan || "";

  if (typeof planLimited === "string" && planLimited.toLowerCase().trim() === "premium") {
    return true;
  }

  const pId =
    pkg?.pId ||
    dbSettings?.pId ||
    dbSettings?.data?.pId ||
    auth?.storeSettings?.pId;

  if (typeof pId === "string") {
    const lowerPId = pId.toLowerCase().trim();
    if (
      lowerPId.includes("premium") ||
      lowerPId.endsWith("-03") ||
      lowerPId.endsWith("-04") ||
      lowerPId === "aid-pos-03" ||
      lowerPId === "aid-pos-04"
    ) {
      return true;
    }
  }

  const customPlan =
    dbSettings?.package ||
    dbSettings?.plan ||
    dbSettings?.data?.package ||
    dbSettings?.data?.plan ||
    auth?.storeSettings?.package ||
    auth?.storeSettings?.plan;

  if (typeof customPlan === "string" && customPlan.toLowerCase().includes("premium")) {
    return true;
  }

  return false;
};

/**
 * Returns the resolved logo URL to display:
 * - If user has premium package: returns store's database photo (or default logo if no store photo is uploaded)
 * - If user DOES NOT have premium package: returns default Aamar Dokan logo (logo.svg)
 */
export const getDisplayLogo = (auth, dbSettings, fallbackLogo = logo) => {
  const isPremium = isPremiumUser(auth, dbSettings);
  if (!isPremium) {
    return fallbackLogo;
  }

  const dbStorePhoto =
    dbSettings?.storePhoto ||
    dbSettings?.photo ||
    dbSettings?.data?.storePhoto ||
    dbSettings?.data?.photo ||
    auth?.storeSettings?.storePhoto ||
    auth?.storeSettings?.photo;

  if (dbStorePhoto) {
    return resolvePhotoUrl(dbStorePhoto, fallbackLogo);
  }

  return fallbackLogo;
};
